import { BaseModalComponentProps } from '@capturi/use-modal'
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from '@chakra-ui/react'
import { Trans, t } from '@lingui/macro'
import { FC } from 'react'
import { useDeleteToken } from '../api/useOrganizationSettings'

type Props = {
  tokenUid: string
  organizationUid: string
}

export const ConfirmDeleteTokenModal: FC<Props & BaseModalComponentProps> = ({
  onClose,
  tokenUid,
  organizationUid,
}) => {
  const { mutate: deleteToken } = useDeleteToken(organizationUid)
  const toast = useToast()

  const handleDeleteToken = () => {
    deleteToken(tokenUid, {
      onSuccess: () => {
        toast({
          title: t`Token deleted`,
          description: t`The token has been deleted successfully`,
          status: 'success',
        })
        onClose()
      },
      onError: (error) => {
        toast({
          title: t`Error deleting token`,
          description: error.message,
          status: 'error',
        })
      },
    })
  }
  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Trans>Delete Token</Trans>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            <Trans>Are you sure you want to delete this token?</Trans>
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="red" onClick={handleDeleteToken}>
            <Trans>Delete</Trans>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
